import React from 'react';

/**
 * AppTablePagination — Footer bar for table pagination.
 *
 * Designed to be passed as the `footer` prop of `AppTableCard`.
 *
 * @param {number}   page           — current page (1-based)
 * @param {number}   lastPage       — total number of pages
 * @param {number}   total          — total item count
 * @param {number}   perPage        — items per page
 * @param {boolean}  [loading]      — disables buttons while loading
 * @param {function} onPageChange   — callback(newPage)
 */
const AppTablePagination = ({
    page,
    lastPage,
    total,
    perPage,
    loading = false,
    onPageChange,
}) => {
    const startItem = total > 0 ? (page - 1) * perPage + 1 : 0;
    const endItem = Math.min(page * perPage, total);

    return (
        <div className="tk-pagination">
            <p className="tk-pagination-info">
                Mostrando <strong>{startItem}</strong> a{' '}
                <strong>{endItem}</strong> de{' '}
                <strong>{total}</strong> resultados
            </p>
            <div className="tk-pagination-btns">
                <button
                    className="tk-page-btn"
                    disabled={page <= 1 || loading}
                    onClick={() => onPageChange(page - 1)}
                >
                    <i className="pi pi-chevron-left" />
                </button>
                <span className="tk-page-indicator">
                    {page} / {lastPage}
                </span>
                <button
                    className="tk-page-btn"
                    disabled={page >= lastPage || loading}
                    onClick={() => onPageChange(page + 1)}
                >
                    <i className="pi pi-chevron-right" />
                </button>
            </div>
        </div>
    );
};

export default AppTablePagination;
